"use client"

import * as React from "react"
import { type VariantProps } from "class-variance-authority"
import { toastVariants } from "components/ui/toast"

type ToastProps = {
  id: string
  title?: string
  description?: string
  action?: React.ReactNode
  variant?: VariantProps<typeof toastVariants>["variant"]
}

const TOAST_LIMIT = 3
const TOAST_REMOVE_DELAY = 5000

const listeners: Array<(toasts: ToastProps[]) => void> = []
let toasts: ToastProps[] = []

function dispatch(toasts: ToastProps[]) {
  listeners.forEach((listener) => listener(toasts))
}

export function toast(toast: Omit<ToastProps, "id">) {
  const id = Math.random().toString(36).slice(2)
  toasts = [...toasts, { ...toast, id }].slice(-TOAST_LIMIT)
  dispatch(toasts)
  
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id)
    dispatch(toasts)
  }, TOAST_REMOVE_DELAY)
}

export function dismiss(id: string) {
  toasts = toasts.filter((t) => t.id !== id)
  dispatch(toasts)
}

export function useToast() {
  const [state, setState] = React.useState<ToastProps[]>(toasts)

  React.useEffect(() => {
    listeners.push(setState)
    return () => {
      const index = listeners.indexOf(setState)
      if (index > -1) listeners.splice(index, 1)
    }
  }, [])

  return {
    toasts: state,
    toast,
    dismiss
  }
}
